import { graphql } from "react-relay";

export const AddEmailProfileMutation = graphql`
  mutation AddEmailProfileMutation(
    $connections: [ID!]!
    $input: EmailConfigurationInput!
  ) {
    addEmailProfile(input: $input) {
      configuration
        @appendNode(
          connections: $connections
          edgeTypeName: "ConfigurationEdge"
        ) {
        id
        profile
        record {
          ... on EmailConfiguration {
            fromEmail
            sesRegion
            smtp {
              port
              server
              ssl
              username
            }
          }
        }
        scope
      }
    }
  }
`;
